var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_c('Loading')], 1) : _vm._e(), _c('Form', {
    ref: "form"
  }, [_c('img', {
    staticClass: "s-rounded-lg s-w-full",
    attrs: {
      "src": _vm.coverImage
    }
  }), _c('h2', {
    staticClass: "s-text-xl s-text-gray-darker s-font-semibold s-mb-2"
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('div', [_c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("商品單價：")]), _c('dd', [_vm._v(_vm._s(_vm.spec.price) + " 元")])]), _c('dl', {
    staticClass: "s-flex"
  }, [_c('dt', [_vm._v("結單時間：")]), _c('dd', [_vm._v(_vm._s(_vm.endAt))])])]), _c('div', {
    staticClass: "s-product-form"
  }, [_c('Counter', {
    staticClass: "s-mb-4",
    attrs: {
      "label": "下單數量",
      "name": "counter",
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.basis,
      "help": "\u4E0B\u55AE\u6578\u91CF\u6700\u591A ".concat(_vm.max, " \u500B\uFF0C\u6700\u5C11 ").concat(_vm.min, " \u500B"),
      "help-class": "s-text-danger"
    },
    model: {
      value: _vm.quantity,
      callback: function callback($$v) {
        _vm.quantity = $$v;
      },
      expression: "quantity"
    }
  }), _c('div', {
    staticClass: "s-flex s-items-center"
  }, [_c('dl', {
    staticClass: "s-flex-shrink-0 s-flex s-items-center s-mr-2"
  }, [_c('dt', {
    staticClass: "s-mr-2"
  }, [_vm._v("金額")]), _c('dd', {
    staticClass: "s-text-xl s-text-secondary s-price"
  }, [_vm._v("$ " + _vm._s(_vm.price))])]), _c('button', {
    staticClass: "s-btn s-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" 確定下單 ")])])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }